module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/File-minus-b5b443dc813922d049c1a97b85816810.svg";